import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog } from '@headlessui/react';

interface RoleChangeModalProps {
  open: boolean;
  onClose: () => void;
  onSave: (role: string) => void;
  currentRole: string;
  isSystemLevel: boolean;
}

export const RoleChangeModal: React.FC<RoleChangeModalProps> = ({
  open,
  onClose,
  onSave,
  currentRole,
  isSystemLevel,
}) => {
  const { t } = useTranslation();
  const [selectedRole, setSelectedRole] = useState(currentRole);

  // Update selectedRole when currentRole changes
  useEffect(() => {
    setSelectedRole(currentRole);
  }, [currentRole]);

  const roles = isSystemLevel ? ['Super Admin', 'User'] : ['Company Admin', 'Company User'];

  const handleSave = () => {
    onSave(selectedRole);
  };

  return (
    <Dialog open={open} onClose={onClose} className="relative z-50">
      <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
      <div className="fixed inset-0 flex items-center justify-center p-4 overflow-y-auto">
        <Dialog.Panel className="bg-white dark:bg-gray-800 rounded-lg max-w-md w-full max-h-[90vh] flex flex-col overflow-hidden my-auto">
          <Dialog.Title className="text-lg font-medium flex-shrink-0 p-6 pb-0 text-gray-900 dark:text-gray-100">
            Change User Role
          </Dialog.Title>
          <div className="flex-1 min-h-0 overflow-y-auto p-6 pt-4">
            <select
              value={selectedRole}
              onChange={(e) => setSelectedRole(e.target.value)}
              className="w-full p-2 border rounded-md mb-4 dark:bg-gray-700 dark:border-gray-600 dark:text-gray-100"
            >
              {roles.map((role) => (
                <option key={role} value={role}>
                  {role}
                </option>
              ))}
            </select>
            <div className="flex justify-end gap-2">
              <button
                onClick={onClose}
                className="px-4 py-2 text-sm bg-gray-200 dark:bg-gray-700 rounded hover:bg-gray-300 dark:hover:bg-gray-600"
              >
                {t('common.cancel')}
              </button>
              <button
                onClick={handleSave}
                className="px-4 py-2 text-sm bg-blue-600 text-white rounded-md hover:bg-blue-700"
              >
                {t('common.save')}
              </button>
            </div>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
};
